import $dataStr from 'fxdom/es/dataStr.js';
import { join, sumBy, sel, strMap, html, compact, go, split } from 'fxjs/es';
import { ProductCardHelper } from '../../../../../../../services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardHelper.ts';
import { GoodsTypeS } from '../../../../../../GoodsType/S/Function/module/GoodsTypeS.js';
import { MpShopProductTmplS } from '../../../../../../MpShop/Product/S/Tmpl/module/MpShopProductTmplS.js';
import { MShopAppAdultTmplS } from '../../../../../../MShop/App/Adult/S/Tmpl/module/MShopAppAdultTmplS.js';
import { MShopAppProductItemS } from '../../../../../../MShop/App/Product/Item/S/Function/module/MShopAppProductItemS.js';
import { makeBpName } from '../../../../../../MShop/App/Product/Item/S/Tmpl/item.js';
import { makeProductPriceHtml } from '../../../../../../MShop/App/Product/Item/S/Tmpl/price.js';
import { MShopCoreTmplS } from '../../../../../../MShop/Core/S/Tmpl/module/MShopCoreTmplS.js';
import { MShopStudioPreDiscountProductS } from '../../../../../../MShop/Studio/PreDiscountProduct/S/Function/module/MShopStudioPreDiscountProductS.js';
import { MShopUtilConstantS } from '../../../../../../MShop/Util/S/Constant/module/MShopUtilConstantS.js';
import { MShopUtilS } from '../../../../../../MShop/Util/S/Function/module/MShopUtilS.js';
import { creatorPriceOfProduct } from '../../../../../../ProductColorPrice/S/fs.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { NessOutboundTmplS } from '../../../../../Outbound/S/Tmpl/module/NessOutboundTmplS.js';

// 기존 상품 아이템거 복사함
export const makeNessLiveProductItemHtml = (
  sub_class = ['v1'],
  cus_class = '',
  data_src,
  is_mobile = false,
) => {
  return (product, live_title) => {
    const {
      id,
      need_adult_check,
      thumbnails,
      name: _name = '',
      rank,
      ordered_at,
      _: {
        spo: { _: { spo_item_stocks = [] } = {} } = {},
        selected_option_group: { title } = {},
        stores_product: {
          goods_type_id,
          sell_start_at,
          sell_end_at,
          public_at,
          quantity,
          is_quantity_public,
          order_count,
          id: stores_product_id,
          _: {
            stores_products_token_gates = [],
            stores_products_like = {},
            store: { domain_name = '', name: store_name = '', logo_img } = {},
          } = {},
        } = {},
        base_product,
        base_product: { thumbnail_ratio, base_product_color_face_url, name: base_product_name } = {},
        pre_discount_product: { pre_discount_price } = {},
      } = {},
    } = product || { _: {} };

    const component = `app-product-item`;

    const origin_price = creatorPriceOfProduct(product);
    const pre_discount_rate = pre_discount_price
      ? MShopStudioPreDiscountProductS.calcDiscountedRateByPercent(pre_discount_price, origin_price)
      : null;

    const name = UtilS.trim(_name);
    const bp_name = makeBpName(base_product_name, title) || '';
    const badges = MShopAppProductItemS.setBadge(
      {
        spo_item_stocks,
        sell_start_at,
        sell_end_at,
        public_at,
        quantity,
        order_count,
        ordered_at,
        is_quantity_public,
        is_sptg: !!stores_products_token_gates.length,
        rank: UtilS.isNessApp() ? rank : null,
        pre_discount_rate,
      },
      false,
    );
    const product_post_msg = {
      screen: {
        type: 'util',
        title: T('mshop::상품상세'),
        uri: `/${T.lang}/${domain_name}/products/${id}`,
      },
    };
    const store_post_msg = {
      screen: {
        type: 'util',
        title: store_name,
        titleImage: logo_img,
        uri: `/${T.lang}/${domain_name}`,
      },
    };
    const cate_item_name = sel('name' + G._en)(base_product?._?.cate_list);

    const texts = {
      review_score: ET('product::review::score'),
      review_count: UtilS.isNessApp()
        ? // plural 이라 warning 뜨는데 무시해도 됨 ..
          ET('ness::review::count', { count: parseInt(product.review_count), lng: 'en' })
        : ET('product::review::count'),
    };

    const has_review = !isNaN(Number(product.review_count)) && product.review_count != 0;

    const isProductSoldOut = () => {
      const is_no_spo_item_stock =
        spo_item_stocks?.length &&
        go(
          spo_item_stocks,
          sumBy(({ quantity }) => quantity),
        ) === 0;
      const is_no_quantity = ProductCardHelper.isLimitedQuantitySoldOut({ quantity, order_count });
      const is_sale_ended = ProductCardHelper.isEndedSale({ sell_end_at });
      return Boolean(is_no_spo_item_stock || is_no_quantity || is_sale_ended);
    };

    const makeThumbnailHtml = () => {
      return need_adult_check
        ? html`<span class="mp-product-img-bg-wrap" style="background-color: #f6f6f6">
            ${MShopAppAdultTmplS.adultItem()}
          </span>`
        : MpShopProductTmplS.thumbnail(
            { thumbnail_ratio, thumbnails, base_product_color_face_url },
            {
              width: 600,
              data_src,
            },
          );
    };

    return html`
      <div
        class="${component} ${strMap((sc) => `${component}--${sc} `, compact(sub_class))} ${cus_class}"
        data-is_sold_out="${isProductSoldOut(product)}"
      >
        ${NessOutboundTmplS.makeNessProductBadgeTmpl(badges, component, is_mobile)}
        <span class="${component}__live-title">${go(live_title, split('\n'), join(html`<br />`))}</span>
        <div class="${component}__top-info">
          <a href="${product_post_msg.screen.uri}" data-post-message="${$dataStr(product_post_msg)}">
            <div class="${component}__img">${makeThumbnailHtml()}</div>
          </a>
          ${MShopUtilS.returnIf(
            !need_adult_check && !UtilS.isNessApp(),
            html`
              <button
                class="${component}__like"
                data-stores_product_id="${stores_product_id}"
                data-already_like="${!!stores_products_like?.id}"
              >
                ${MShopCoreTmplS.heartIcon({
                  is_on: !!stores_products_like?.id,
                  klass: `${component}__heart`,
                  type: 'solid',
                })}
              </button>
            `,
          )}
        </div>
        <div class="${component}__bottom-info">
          ${MShopUtilS.returnIf(
            !need_adult_check && UtilS.isNessApp(),
            html`
              <button
                class="${component}__like"
                data-stores_product_id="${stores_product_id}"
                data-already_like="${!!stores_products_like?.id}"
              >
                ${MShopCoreTmplS.heartIcon({
                  is_on: !!stores_products_like?.id,
                  klass: `${component}__heart`,
                  type: 'solid',
                })}
              </button>
            `,
          )}
          ${MShopUtilS.returnIf(
            rank,
            `
              <a
                href="${store_post_msg.screen.uri}"
                data-post-message="${$dataStr(store_post_msg)}"
                class='${component}__rank'
              >
                <span>${rank}</span>
              </a>
            `,
          )}
          <a
            href="${store_post_msg.screen.uri}"
            data-post-message="${$dataStr(store_post_msg)}"
            class="${component}__store-name"
          >
            ${store_name}
          </a>
          <a href="${product_post_msg.screen.uri}" data-post-message="${$dataStr(product_post_msg)}">
            <div class="${component}__p-name">
              ${GoodsTypeS.isMps(goods_type_id)
                ? (!need_adult_check && name) || bp_name || '&nbsp;'
                : name || '&nbsp;'}
            </div>
            <div class="${component}__category-name">${cate_item_name}</div>
            ${makeProductPriceHtml(product, component)}
          </a>
          <div
            class="${component}__review-info ${MShopUtilS.returnIf(
              !has_review,
              `${component}__review-info--hidden`,
            )}"
          >
            <span class="${component}__review-score">
              <span class="${component}__review-title">${texts.review_score}</span>
              <span class="${component}__review-number ${MShopUtilConstantS.UNICA_KLASS}"
                >${product.review_score || 0}</span
              >
            </span>
            <span class="${component}__review-count">
              <span class="${component}__review-title">${texts.review_count}</span>
              <span class="${component}__review-number ${MShopUtilConstantS.UNICA_KLASS}">
                ${UtilS.commaThousands(product.review_count || 0)}
              </span>
            </span>
          </div>
        </div>
      </div>
    `;
  };
};
